// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../../../home/tiger/.nvm/versions/node/v12.4.0/lib/node_modules/@ies/eden/node_modules/@ies/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._2w1bXBlSrT8yqHLJQlTExH{width:100%;box-sizing:border-box}._2ntpRcmfpGqZSEPyCik27q{display:flex;flex-wrap:wrap;justify-content:space-between;margin-top:.4rem}._2SR_aBxP8Xlh991ivCq_y3{margin:.40rem 0}._3fhFiXzpJOJVoplNBP8oEJ{width:.56rem;height:.56rem;margin-right:.12rem}._1Tv3CMgQxuYveK4KcJ1r5m{margin-top:3.50rem;display:flex;justify-content:center;align-items:center;width:100%}._2fzaJdK9z6unePPSjbLJ00{font-size:16px;line-height:19px;text-align:center;max-width:4rem;color:#97999c}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"skeleton": "_2w1bXBlSrT8yqHLJQlTExH",
	"wrap": "_2ntpRcmfpGqZSEPyCik27q",
	"header": "_2SR_aBxP8Xlh991ivCq_y3",
	"pic": "_3fhFiXzpJOJVoplNBP8oEJ",
	"refresh": "_1Tv3CMgQxuYveK4KcJ1r5m",
	"text": "_2fzaJdK9z6unePPSjbLJ00"
};
module.exports = ___CSS_LOADER_EXPORT___;
